import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBYJVVH_WprzSi3SsrV1haeILQgjwtgaco",
  authDomain: "klerk-cf0cb.firebaseapp.com",
  projectId: "klerk-cf0cb",
  storageBucket: "klerk-cf0cb.firebasestorage.app",
  messagingSenderId: "299187185509",
  appId: "1:299187185509:web:7abe9fc7dd3c0b7dac638c"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { db, auth }